export const CHECK_EMAIL_PROFILE = false;

export const SEGMENT_ENABLED = true;
